import { EnvironmentProviders, inject, makeEnvironmentProviders, provideEnvironmentInitializer } from '@angular/core';
import { ThemeFacade } from '@core/theme/facades/theme.facade';

export const provideTheme = (): EnvironmentProviders =>
  makeEnvironmentProviders([
    provideEnvironmentInitializer(() => {
      inject(ThemeFacade);
    }),
  ]);
